import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{
        orderId?: string;
    }>(location.search);
    const orderNumber = parsedQuery.orderId ?? parsedQuery.orderId;

    return {
        orderData: orderNumber ? state.WhiteCap.customOrderStatusPage.orderStatusById[orderNumber] : null,
        pageType: getCurrentPage(state).type,
    };
};

type Props = ReturnType<typeof mapStateToProps>;
export interface OrderPoStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    orderItem?: TypographyPresentationProps;
}

export const orderItemCountStyles: OrderPoStyles = {
    wrapper: {
        css: css`
            /* padding-bottom: 10px; */
            text-align: center;
        `,
    },
    orderItem: {
        css: css`
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 12px;
                    `,
                    css`
                        font-size: 12px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 0px;
            text-align: center;
            text-transform: uppercase;
            font-weight: 400;
            font-size: 14px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 12px;
                        margin-bottom: 0px;
                    `,
                    css`
                        font-size: 12px;
                        margin-bottom: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const styles = orderItemCountStyles;

const OrderItemCount: FC<Props> = ({ pageType, orderData }) => {
    const order = pageType === "CustomOrderStatusPage" ? orderData : useContext(OrderStateContext).value;

    if (!order || !order.orderLines) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h2" {...styles.titleText} id="orderItemCount">
                {translate("Total Items")}
            </Typography>
            <Typography {...styles.orderItem} aria-labelledby="orderItemCount">
                {order.orderLines.length}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderItemCount),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage", "CustomOrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;
